import classNames from 'classnames'
import React from 'react'

import { IButtonVariant } from '~/types/strapi'

import Button from '../base'
import { ButtonProperties } from '../types'

interface VariantProperties {
  variant: IButtonVariant
  tiny?: boolean
}

type Properties = VariantProperties & ButtonProperties

const VariantButton: React.FC<Properties> = ({
  variant = 'filled-red',
  className,
  children,
  tiny,
  ...rest
}) => {
  const buttonClassName = classNames(
    'flex items-center justify-center rounded-[2rem] transition-colors leading-none text-balance text-center font-sans-16 uppercase',
    {
      'px-9 h-11 text-base': !tiny,
      'px-6 h-9 text-sm': tiny,
    },
    {
      'bg-red-600 text-neutral-white hover:bg-red-700':
        variant === 'filled-red',
      'bg-wine-900 text-neutral-white hover:bg-wine-700':
        variant === 'filled-wine',
      'bg-green-200 text-neutral-black hover:bg-green-400':
        variant === 'filled-green',
      'bg-green-300 text-neutral-black hover:bg-neutral-black hover:text-neutral-white':
        variant === 'filled-green-dark',
      'bg-neutral-white text-neutral-black hover:bg-neutral-black hover:text-neutral-white':
        variant === 'filled-white',
      'bg-transparent border-2 border-neutral-black text-neutral-black hover:bg-red-600 hover:border-red-600 hover:text-neutral-white':
        variant === 'outline-black',
      'bg-transparent border-2 border-neutral-white text-neutral-white hover:bg-neutral-black hover:border-neutral-black':
        variant === 'outline-white',
      'bg-transparent border-2 border-current text-current hover:bg-red-500 hover:border-red-500 hover:text-neutral-white':
        variant === 'outline-current',
    },
    className
  )

  return (
    <Button className={buttonClassName} {...rest}>
      {children}
    </Button>
  )
}

export default VariantButton
